"use client";

import React from "react";

import {cn} from "@/lib/utils";
import Image from "next/image";
import {motion, MotionProps} from "framer-motion";
import ethereumIcon from "@/public/icons/ethereum.svg";
import bitcoinIcon from "@/public/icons/bitcoin.svg";
import solanaIcon from "@/public/icons/solana.svg";

const cryptoIcons = {
  bitcoin: bitcoinIcon,
  ethereum: ethereumIcon,
  solana: solanaIcon,
} as const;

const cryptoIconWidths = {
  bitcoin: "2.5rem",
  ethereum: "2.25rem",
  solana: "2.875rem",
} as const;

interface CryptoPillarProps extends MotionProps {
  type: "bitcoin" | "ethereum" | "solana";
  className?: string;
  trailColors?: string;
  badgeColors?: string;
}

export default function CryptoPillar({
  type,
  className,
  trailColors,
  badgeColors,
  ...motionProps
}: CryptoPillarProps) {

  return (
    <motion.div
      className={cn(
        "absolute bottom-0 w-[5.5rem] h-[25rem]",
        className
      )}
      {...motionProps}
    >
      <div className="relative w-full h-full rounded-t-full overflow-clip">
        <div className={cn(
          "absolute top-0 left-0 w-full h-full",
          trailColors || "bg-gradient-to-b from-[#E6F2EB] from-[-33%] via-[#103037]/30 via-[30%] to-[#103037]/0"
        )}/>

        <div className={cn(
          "w-full aspect-square rounded-full bg-white flex items-center justify-center absolute top-0 left-0",
          badgeColors
        )}>
          <Image
            style={{
              width: cryptoIconWidths[type],
              height: "auto"
            }}
            src={cryptoIcons[type]}
            alt={`${type} icon`}
          />
        </div>
      </div>
    </motion.div>
  );
}
